export const urlPlaceholders = {
  userId: '{userId}',
  hash: '{hash}',
  video: '{name}',
};
